import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface SidenavContent {
  component: any;
  data?: any;
  wineries?: any[];
}

@Injectable({
  providedIn: 'root'
})
export class SidenavContentService {
  private sidenavContentSubject = new BehaviorSubject<SidenavContent | null>(null);
  public sidenavContent$ = this.sidenavContentSubject.asObservable();

  openContent(component: any, data?: any, wineries?: any[]) {
    this.sidenavContentSubject.next({ component, data, wineries });
  }

  closeContent() {
    this.sidenavContentSubject.next(null);
  }
}
